import type { AppRouteRecordRaw } from '@/types/router';
import DatabaseFilled from '@vicons/antd/es/DatabaseFilled';
import FacebookFilled from '@vicons/antd/es/FacebookFilled';
import { LAYOUT } from '@/router/constants';

const comp: AppRouteRecordRaw = {
  path: '/comp',
  name: 'Comp',
  redirect: '/comp/form',
  component: LAYOUT,
  meta: {
    title: '组件',
    icon: DatabaseFilled,
  },
  children: [
    {
      path: 'form',
      name: 'CompForm',
      component: () => import('@/views/comp/form/index.vue'),
      meta: {
        title: '表单',
        icon: FacebookFilled,
      },
    },
    {
      path: 'select',
      name: 'CompSelect',
      component: () => import('@/views/comp/select/index.vue'),
      meta: {
        title: 'Select',
        icon: FacebookFilled,
      },
    },
    {
      path: 'loading',
      name: 'CompLoading',
      component: () => import('@/views/comp/loading/index.vue'),
      meta: {
        title: 'Loading',
        icon: FacebookFilled,
      },
    },
    {
      path: 'upload',
      name: 'CompUpload',
      component: () => import('@/views/comp/upload/index.vue'),
      meta: {
        title: 'Upload',
        icon: FacebookFilled,
      },
    },
    {
      path: 'dialog',
      name: 'CompDialog',
      component: () => import('@/views/comp/dialog/index.vue'),
      meta: {
        title: 'Dialog',
        icon: FacebookFilled,
      },
    },
    {
      path: 'category',
      name: 'CompCategory',
      component: () => import('@/views/comp/category/index.vue'),
      meta: {
        title: 'Category',
        icon: FacebookFilled,
      },
    },
    {
      path: 'table',
      name: 'CompTable',
      component: () => import('@/views/comp/table/index.vue'),
      meta: {
        title: 'Table',
        icon: FacebookFilled,
      },
    },
  ],
};

export default comp;
